// src/components/common/QuestionsList.jsx
import React from "react";
import DefaultButton from "../buttons/DefaultButton";

function QuestionsList({questions = [], onEdit, isChild = false}) {
    if (!questions?.length) return null;

    const handleEdit = (question, isChild) => {
        if (onEdit) {
            onEdit(question, isChild);
        }
    };

    return (
        <div>
            {questions.map((question, index) => (
                <div key={question.ID ?? index} className="my-2">
                    <div className="text-lg font-semibold">Vraag {index + 1}:</div>
                    <div className="text-base">{question.Question}</div>
                    <DefaultButton
                        content="Bewerken"
                        onClick={() => handleEdit(question, isChild)}
                    />
                </div>
            ))}
        </div>
    );
}

export default QuestionsList;